import { get, writable } from 'svelte/store';
import { FeatureSet, ReleaseStage, stateFeatureSet, wantAtLeastReleaseStage } from '@infinitro/config';
/** When true, the in-app support chat shell is visible (Preview + Alpha embed). */
export const stateSupportChatOpen = writable(false);
export function isSupportChatEmbedActive() {
    return get(stateFeatureSet) === FeatureSet.Preview && wantAtLeastReleaseStage(ReleaseStage.Alpha);
}
export function toggleSupportChatOpen() {
    stateSupportChatOpen.update((open) => !open);
}
